import { AIProviderType } from '../../../services/settingsService';

export interface ProviderMeta {
  id: AIProviderType;
  name: string;
  /** Where an admin creates an API key */
  keyUrl: string;
  keyPlaceholder: string;
}

export const AI_PROVIDERS: ProviderMeta[] = [
  { id: 'claude', name: 'Claude', keyUrl: 'https://console.anthropic.com', keyPlaceholder: 'sk-ant-…' },
  { id: 'deepseek', name: 'DeepSeek', keyUrl: 'https://platform.deepseek.com', keyPlaceholder: 'sk-…' },
  { id: 'gemini', name: 'Gemini', keyUrl: 'https://aistudio.google.com/apikey', keyPlaceholder: 'AIza…' },
  { id: 'kimi', name: 'Kimi', keyUrl: 'https://platform.kimi.ai', keyPlaceholder: 'sk-…' },
  { id: 'openai', name: 'OpenAI', keyUrl: 'https://platform.openai.com/api-keys', keyPlaceholder: 'sk-…' },
  { id: 'perplexity', name: 'Perplexity', keyUrl: 'https://docs.perplexity.ai', keyPlaceholder: 'pplx-…' },
  {
    id: 'qwen',
    name: 'Qwen',
    keyUrl: 'https://www.alibabacloud.com/help/en/model-studio/get-api-key',
    keyPlaceholder: 'sk-…',
  },
];

export const providerName = (id: string | undefined): string =>
  AI_PROVIDERS.find((provider) => provider.id === id)?.name ?? id ?? '';

/** "sk-a********9f2c" → "sk-a…9f2c" */
export function shortKey(masked: string): string {
  if (!masked) return '';
  const trimmed = masked.replace(/\*+/g, '…');
  return trimmed.length > 16 ? `${trimmed.slice(0, 6)}…${trimmed.slice(-4)}` : trimmed;
}
